export default __webpack_public_path__ + "5048dbdcca78b8c20d034c7784b3f060.jpg";